<template>
  <w-scale :scaleShow="feedbackVisibile" :top="32">
      <div class="special-content" slot="content">
        <div class="special-title">求职意向反馈</div>
        <div class="special-contents">
          <input type="text" class="feed-input" placeholder="请输入你的意向职位" v-model="feedInfo">
        </div>
        <div class="special-footer">
          <div class="item clo98 boder-right" @click="cancle">取消</div>
          <div class="item cloF6 boder-left" @click="confirm">立即反馈</div>
        </div>
      </div>
    </w-scale>
</template>
<script>
  import WScale from '@/components/global/w-scale'
  import Cookies from 'js-cookie'
  import { componentsMixin } from '@/assets/js/mixin/components'
  export default{
    name:'Feedback',
    mixins: [  componentsMixin ],
    props:['feedbackVisibile'],
    components:{
      WScale
    },
    data(){
      return {
        feedInfo:'',
      }
    },
    methods:{
      cancle(){
        this.$emit('closeFeed')
      },
      async confirm(){
        var that = this
        let _t = Cookies.get('_t')
        let token = JSON.parse(window.atob(_t.split('.')[1])).User.c_t
        if(this.feedInfo === '') return
        let res = await  this.$api.user.feedbackSubmit({
          feedback_platform: 'mobile_vue',
          feedback_type: 6,
          content: this.feedInfo,
          token
        })
        if(res.code === 1000){
		  this.showToast('感谢您的反馈')
          this.cancle()
        }
      }
    }
  }
</script>
<style scoped lang="scss">
.special-content{
  background: #FEFFFF;
  border-radius: 12px;
  width:100%;
  min-width: 319px;
  .special-title{
    padding: 27px 0 20px 0;
    text-align: center;
    font-size: 16px;
    color: #404040;
  }
  .special-contents{
    .feed-input{
      background: #F9F9F9;
      border-radius: 19px;
      border: none;
      outline: none;
      padding: 9px 20px;
      width: 85%;
      display: block;
      margin: 0 auto;
    }
    .feed-input::-webkit-input-placeholder{
      color:#BCBCBC;
    }
    .feed-input::-moz-placeholder{   /* Mozilla Firefox 19+ */
      color:#BCBCBC;
    }
    .feed-input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
      color:#BCBCBC;
    }
    .feed-input:-ms-input-placeholder{  /* Internet Explorer 10-11 */ 
      color:#BCBCBC;
    }
  }
  .special-footer{
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-items: center;
    margin-top: 24px;
    .item{
      width: 50%;
      text-align: center;
      padding: 15px 0;
      border-top:1px solid #F4F4F4;
    }
    .cloF6{
      color: #FF6644;
    }
    .clo98{
      color: #98999A;
    }
    .boder-right{
      border-right:1px solid #F4F4F4;
    }
  }
}
</style>